/* global FB */

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { 
  getAssistantDetails, 
  getAllVectorStores, 
  associateVectorStoreToAssistant, 
  enableFileSearchForAssistant,
  disableFileSearchForAssistant, 
  sendMessage,  
  updateAssistantInstructions,
  deleteAssistant,
  updateAssistantName
} from '../services/openaiService'; 
import './AssistantChat.css'; // Importa los estilos específicos de AssistantChat
import logo from '../assets/logotheting.png';  // Importa el logo
import Sidebar from './Sidebar';
import VoiceMessagePlayer from './VoiceMessagePlayer';
import { Link } from 'react-router-dom';
import { db } from '../firebase'; // Importa la instancia correcta de Firestore
import { doc, getDoc, setDoc, deleteDoc, deleteField, updateDoc } from 'firebase/firestore'; 
import { auth } from '../firebase';
import { onAuthStateChanged, getAuth } from 'firebase/auth'; 
import { AssistantContext } from '../context/AssistantContext';
// Importa el paquete de selectores de color
import { SketchPicker } from 'react-color'; // Asegúrate de instalar react-color
import { faFilePdf, faFolderOpen, faTrash, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';   // ⬆️ en tus imports
import { toast } from 'react-toastify';


// Importa las imágenes predeterminadas
import defaultBubbleBlack from '../assets/Burbuja-chat-predeterminada-negra.png';
import defaultBubbleViolet from '../assets/Burbuja-chat-predeterminada-violeta.png';
import defaultBubbleWhite from '../assets/Burbuja-chat-predeterminada-blanca.png'; 
import defaultBubbleRed from '../assets/Burbuja-chat-predeterminada-rojo.png';
import defaultBubbleGreen from '../assets/Burbuja-chat-predeterminada-verde.png';
import defaultBubbleBlue from '../assets/Burbuja-chat-predeterminada-azul.png';
import defaultBubbleYellow from '../assets/Burbuja-chat-predeterminada-amarilla.png';
import defaultBubbleText from '../assets/burbuja-predeterminada-texto.png';

import chatIcon from '../assets/icon-chat.png';

import backgroundImage from '../assets/background-bubble.png';

import { useAuth } from '../context/AuthContext'; // Asegúrate de tener este contexto definido

// src/components/AssistantChat.js

import paperClipButton from '../assets/paper-clip-button.png'; // Ajusta la ruta según tu estructura de carpetas
import { faComments, faDownload, faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExpandArrowsAlt, faCompressArrowsAlt } from '@fortawesome/free-solid-svg-icons';



import paintBrushIcon from '../assets/paint-brush.png';
import { color } from 'd3';



 

const AssistantChat = () => {
  
  const [isFacebookSDKReady, setIsFacebookSDKReady] = useState(false);
  const { assistantId } = useParams();

  const { assistantName, setAssistantName } = useContext(AssistantContext);

  
  const [assistantDetails, setAssistantDetails] = useState(null);
  const [messages, setMessages] = useState([]);


  const [isFullScreenInstructions, setIsFullScreenInstructions] = useState(false);
//  👆 deja tu estado como está…
const toggleFullScreen = () => {
  setIsFullScreenInstructions(prev => {
    const next = !prev;

    /* ─── Al entrar ───────────────────────────────────── */
    if (next) {
      // si todavía no estabas editando, comienza a editar
      if (!isEditingInstructions) {
        setNewInstructions(assistantDetails?.instructions || '');
        setIsEditingInstructions(true);
      }
    }

    /* ─── Al salir ────────────────────────────────────── */
    if (!next) {
      const textActual   = assistantDetails?.instructions || '';
      const hayCambios   = newInstructions !== textActual;
      const quiereSalir  = !hayCambios || window.confirm(
        'Tienes cambios sin guardar. ¿Seguro que quieres salir sin guardar?'
      );
      if (!quiereSalir) return true;      //  -> cancela la salida
    }

    return next;
  });
};

  

  const [input, setInput] = useState('');
  const [vectorStores, setVectorStores] = useState([]); 
  const [selectedKnowledgeBase, setSelectedKnowledgeBase] = useState('');
  const [isKnowledgeBaseEnabled, setIsKnowledgeBaseEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [isEditingInstructions, setIsEditingInstructions] = useState(false);
  const [newInstructions, setNewInstructions] = useState('');
  const [threadId, setThreadId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para el modal
  const [apiKey, setApiKey] = useState(localStorage.getItem('API_KEY') || '');

  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [newName, setNewName] = useState('');
  const [isEditingName, setIsEditingName] = useState(false);

  const [activePlatform, setActivePlatform] = useState('whatsapp');

  const [headerColor, setHeaderColor] = useState('#6268D4');
const [bubbleButtonColor, setBubbleButtonColor] = useState('#FFFFFF0');
const [messageUserColor, setMessageUserColor] = useState('#57238F');
const [messageAssistantColor, setMessageAssistantColor] = useState('#406AD5');

const [chatIconButtonColor, setChatIconButtonColor] = useState('#693DD7');
const [isChatIconButtonColorPickerOpen, setIsChatIconButtonColorPickerOpen] = useState(false);


  // 1) Nuevo estado para color del ícono:
  const [chatIconColor, setChatIconColor] = useState('#ffffff');
  const [isChatIconColorPickerOpen, setIsChatIconColorPickerOpen] = useState(false);

const [bubbleButtonImage, setBubbleButtonImage] = useState(''); // Para la imagen del botón de la burbuja

const [useBackgroundImage, setUseBackgroundImage] = useState(true);

// Dentro de tu componente AssistantChat, al inicio donde defines estados:
const [messageContentColor, setMessageContentColor] = useState('#FFFFFF');
const [isMessageContentColorPickerOpen, setIsMessageContentColorPickerOpen] = useState(false);

const [backgroundColor, setBackgroundColor] = useState('#FFFFFF');

const [assistantMessagesQueue, setAssistantMessagesQueue] = useState([]);
// Tamaño del botón‑burbuja (px). 70 px coincide con tu CSS actual.
const [bubbleButtonSize, setBubbleButtonSize] = useState(70);

const { currentUser } = useAuth();


// AssistantChat.js
const defaultBubbleYellow = 'https://platform.thethingapp.com/images/Burbuja-chat-predeterminada-amarilla.png';
const defaultBubbleBlack = 'https://platform.thethingapp.com/images/Burbuja-chat-predeterminada-negra.png';
const defaultBubbleViolet = 'https://platform.thethingapp.com/images/Burbuja-chat-predeterminada-violeta.png';
const defaultBubbleWhite = 'https://platform.thethingapp.com/images/Burbuja-chat-predeterminada-blanca.png';
const defaultBubbleRed = 'https://platform.thethingapp.com/images/Burbuja-chat-predeterminada-rojo.png';
const defaultBubbleGreen = 'https://platform.thethingapp.com/images/Burbuja-chat-predeterminada-verde.png';
const defaultBubbleBlue = 'https://platform.thethingapp.com/images/Burbuja-chat-predeterminada-azul.png';
const defaultBubbleText = 'https://platform.thethingapp.com/images/burbuja-predeterminada-texto.png';
// Dentro del componente
const modalRef = useRef(null);
const isCoexistenceSignupRef = useRef(false);
const signupProcessedRef = useRef(false);

const [activeTab, setActiveTab] = useState('codigo'); // 'codigo' es la pestaña predeterminada


  // Añade estos estados al inicio del componente
  const [pin, setPin] = useState('');
  const [isPinModalOpen, setIsPinModalOpen] = useState(false);

  // Añade este estado al inicio del componente
const [currentUserUid, setCurrentUserUid] = useState(null);
// arriba, con el resto de los useState
const [isSavingInstructions, setIsSavingInstructions] = useState(false);
/* --- UN-SAVED CHANGES ----------------------------------- */
const [dirtyInstructions, setDirtyInstructions] = useState(false);

// Nuevo estado para el spinner de subida de archivos
const [isUploadingFiles, setIsUploadingFiles] = useState(false);


/* helper que pregunta solo cuando hace falta */
const confirmLeave = (msg = 'Tienes cambios sin guardar. ¿Salir sin guardar?') =>
  !dirtyInstructions || window.confirm(msg);


  // Estados para manejar la apertura de los color pickers
  const [isHeaderColorPickerOpen, setIsHeaderColorPickerOpen] = useState(false);
  const [isBubbleButtonColorPickerOpen, setIsBubbleButtonColorPickerOpen] = useState(false);
  const [isMessageUserColorPickerOpen, setIsMessageUserColorPickerOpen] = useState(false);
  const [isMessageAssistantColorPickerOpen, setIsMessageAssistantColorPickerOpen] = useState(false);
  const [isBackgroundColorPickerOpen, setIsBackgroundColorPickerOpen] = useState(false);

  const [showChatIconButton, setShowChatIconButton] = useState(true);

    // *** NUEVO *** Ref para el input de imágenes:
    const imageFileInputRef = useRef(null);

  // Al inicio del componente, importa y define el ref y las funciones:
const instructionsFileInputRef = useRef(null);

const handleUploadInstructionsButton = () => {
  if (instructionsFileInputRef.current) {
    instructionsFileInputRef.current.click();
  }
};

// ⬆️  (mantenlo junto con el resto de useState)

const [isGalleryOpen, setIsGalleryOpen] = useState(false);   // Modal on/off

const [galleryFiles, setGalleryFiles] = useState([]); // [{ url, type: 'image'|'pdf', name }]
const [hasFiles, setHasFiles] = useState(false);

// justo al lado de isGalleryOpen…
const [isDocsOpen, setIsDocsOpen] = useState(false);

// (justo después de const [bubbleButtonSize, setBubbleButtonSize] …)
const [isCustomBubble, setIsCustomBubble] = useState(false);

/* guarda el tamaño REAL que ocupa la imagen ya renderizada */
const [bubbleDims, setBubbleDims] = useState({ width: bubbleButtonSize * 0.8, height: bubbleButtonSize * 0.8 });

/* referencia a la <img> principal para poder medirla */
const bubbleImgRef = useRef(null);



const handleInstructionsUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  // Función auxiliar para aplicar el texto subido
  const applyUploadedText = (uploadedText) => {
    // Tomamos el contenido existente (ya sea en newInstructions o en assistantDetails.userInstructions)
    const existingText = (newInstructions || (assistantDetails && assistantDetails.userInstructions)) || "";
    if (existingText.trim().length > 0) {
      const replace = window.confirm(
        "Ya existen instrucciones en este agente. ¿Deseas reemplazarlas? (Si presionas cancelar, tu nuevo documento se agregará al final de las instrucciones existentes)"
      );
      if (replace) {
        setNewInstructions(uploadedText);
      } else {
        // Concatenar el nuevo texto al final del existente, separándolo con un salto de línea
        setNewInstructions(existingText + "\n" + uploadedText);
      }
    } else {
      setNewInstructions(uploadedText);
    }
    setIsEditingInstructions(true);
  };

  // Verificar si es un DOCX por extensión o MIME type
  const isDocx =
    file.name.toLowerCase().endsWith(".docx") ||
    file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

  if (isDocx) {
    // Si es DOCX, enviarlo al endpoint de conversión
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await fetch("https://backend.thethingapp.com/upload-docx", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.success) {
        applyUploadedText(data.text);
      } else {
        console.error("Error en la conversión DOCX:", data.error);
      }
    } catch (error) {
      console.error("Error al subir el archivo DOCX:", error);
    }
  } else {
    // Si es otro tipo de archivo (txt, html, md, etc.), leerlo directamente
    const reader = new FileReader();
    reader.onload = (event) => {
      applyUploadedText(event.target.result);
    };
    reader.readAsText(file);
  }
};

  // *** NUEVO *** Función que verifica o crea la carpeta, luego lanza la selección de imágenes:
  const handleCreateFolderButtonClick = async () => {
    try {
      // Llamada al backend que verifica/crea la carpeta "assistants/assistantId"
      const response = await fetch('https://backend.thethingapp.com/api/create-folder', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          mainFolder: 'assistants',
          subFolder: assistantId
        })
      });
      const data = await response.json();
      if (data.success) {
        // Si la carpeta existe o se creó, ahora permitir selección de imágenes
        if (imageFileInputRef.current) {
          imageFileInputRef.current.click();
        }
      } else {
        console.error('Error creando/verificando la carpeta:', data.error);
        toast.error('❌ Error creando/verificando la carpeta.');
      }
    } catch (error) {
      console.error('Error en la solicitud de carpeta:', error);
      toast.error('❌ Error creando/verificando la carpeta.');
    }
  };

  const handleFilesSelected = async (e) => {
    console.log('[handleFilesSelected] archivos seleccionados:', e.target.files);
  
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
  
    // Define límites en bytes
    const LIMITS = {
      image: 5 * 1024 * 1024,      // 5 MB
      video: 16 * 1024 * 1024,     // 16 MB
      audio: 16 * 1024 * 1024,     // 16 MB
      document: 100 * 1024 * 1024, // 100 MB
    };
  
    const docExts = ['.txt','.pdf','.doc','.docx','.xls','.xlsx','.ppt','.pptx'];
  
    // Filtrar solo archivos válidos
// …dentro de handleFilesSelected
const validFiles = files.filter(file => {
  const { name, size, type } = file;


  /* 2 · valida tipo / tamaño (igual que antes) */
  let category;
  if (type.startsWith('image/'))       category = 'image';
  else if (type.startsWith('video/'))  category = 'video';
  else if (type.startsWith('audio/'))  category = 'audio';
  else {
    const ext = name.slice(name.lastIndexOf('.')).toLowerCase();
    if (['.txt','.pdf','.doc','.docx','.xls','.xlsx','.ppt','.pptx'].includes(ext))
      category = 'document';
  }

  if (!category) {
    toast.error(`Tipo no permitido: ${name}`);
    return false;
  }

  const LIMITS = { image:5e6, video:16e6, audio:16e6, document:1e8 };
  if (size > LIMITS[category]) {
    const human = { image:'5 MB', video:'16 MB', audio:'16 MB', document:'100 MB' }[category];
    toast.error(`${name} excede ${human}.`);
    return false;
  }
  return true;
});

  
    console.log('[handleFilesSelected] validFiles después de filtrar:', validFiles.map(f => f.name));
    if (validFiles.length === 0) {
      console.log('[handleFilesSelected] No hay archivos válidos para subir.');
      return;
    }
  
    // Mostrar spinner antes de iniciar la subida
    setIsUploadingFiles(true);
  
    // --- lógica de subida ---
    const formData = new FormData();
    formData.append('folderPath', `assistants/${assistantId}`);
    validFiles.forEach(f => formData.append('files', f));
  
    try {
      console.log('[handleFilesSelected] iniciando fetch de subida...');
      const res = await fetch('https://backend.thethingapp.com/api/upload-mixed', {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      console.log('[handleFilesSelected] respuesta de subida:', data);
      if (data.success) {
        console.log('[handleFilesSelected] Archivos subidos correctamente.');
        toast.success('✔ Archivos subidos correctamente');
        // ✨ Recargar la galería inmediatamente ✨
        await loadGalleryFiles();
      } else {
        console.error('[handleFilesSelected] Error en la subida:', data.error);
        toast.error(`❌ ${data.error || 'Error subiendo archivos.'}`);
      }
      
    } catch (err) {
      console.error('[handleFilesSelected] Error de red al subir archivos:', err);
      toast.error('❌ Error de red al subir archivos.');
    } finally {
      // Ocultar spinner al finalizar (éxito o error)
      setIsUploadingFiles(false);
    }
  };
  
  // === NUEVO: función para recargar la galería ===
const loadGalleryFiles = async () => {
  try {
    const res = await fetch(
      `https://backend.thethingapp.com/api/list-files?assistantId=${assistantId}`
    );
    const { success, files } = await res.json();
    console.log('[loadGalleryFiles] éxito:', success, ' | files:', files);

    if (success) {
      const mapped = files.map(f => {
        let type = 'file';
        if (f.mimeType.startsWith('image/')) type = 'image';
        else if (f.mimeType.startsWith('video/')) type = 'video';
        else if (/\.(mp4|mov|avi|webm)$/i.test(f.originalName)) type = 'video';
        else if (f.mimeType.startsWith('audio/')) type = 'audio';
        else if (f.mimeType === 'application/pdf') type = 'pdf';
        else if (/\.(xls|xlsx|doc|docx|ppt|pptx)$/i.test(f.originalName)) type = 'office';
// después: aplicamos decodeURIComponent para forzar la codificación UTF-8
return {
  url: f.url,
  type,
  name: decodeURIComponent( escape(f.originalName) )

};

      });
      console.log('[loadGalleryFiles] mapeado →', mapped);
      setGalleryFiles(mapped);
      setHasFiles(mapped.length > 0);
    } else {
      toast.error('❌ No se pudieron cargar los archivos existentes');
    }
  } catch (e) {
    console.error('Error cargando galleryFiles:', e);
    toast.error('❌ Error cargando archivos');
  }
};

  
useEffect(() => {
  loadGalleryFiles();
}, [assistantId]);


  
    
const handleDocxUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;
  
  // Creamos un FormData para enviar el archivo
  const formData = new FormData();
  formData.append('file', file);
  
  try {
    // Envía el archivo al endpoint de tu servidor
    const response = await fetch('https://backend.thethingapp.com/upload-docx', {
      method: 'POST',
      body: formData
    });
    const data = await response.json();
    
    if (data.success) {
      // Actualiza el estado con el texto convertido
      setNewInstructions(data.text);
      setIsEditingInstructions(true);
    } else {
      console.error('Error en la conversión:', data.error);
    }
  } catch (error) {
    console.error('Error al subir el archivo:', error);
  }
};



  // Estado para detectar si la pantalla es móvil
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1280);

    // Función para limpiar (reiniciar) el thread:
    const handleClearThread = () => {
      if (window.confirm("¿Estás seguro de que deseas reiniciar la conversación? Esto borrará el historial.")) {
        // Reiniciamos el thread: se borra el threadId y el historial de mensajes
        setThreadId(null);
        setMessages([]);
        setAssistantMessagesQueue([]);
        // Opcional: Si guardas información en Firestore o en otro lado, aquí podrías también eliminarla
      }
    };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1280);
    };

    // Añadir listener para eventos de resize
    window.addEventListener('resize', handleResize);

    // Limpiar el listener al desmontar el componente
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Función para abrir el modal del PIN 
  const handleOpenPinModal = () => setIsPinModalOpen(true);
  const handleClosePinModal = () => setIsPinModalOpen(false);
  useEffect(() => {
    const fetchApiKeyAndPassKey = async () => {
      const user = auth.currentUser;
      if (user) {
        const userId = user.uid;
        const token = await user.getIdToken();
  
        try {
          // Obtener la API_KEY
          const response = await fetch(`https://backend.thethingapp.com/api/get-openai-key?userId=${userId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          }); 
          const data = await response.json();
  
          if (data.apiKey) {
            localStorage.setItem('API_KEY', data.apiKey);
            setApiKey(data.apiKey);
  
            // Obtener el PASS_KEY
            const passKeyResponse = await fetch(`https://backend.thethingapp.com/api/get-passkey?assistantId=${assistantId}`, {
              headers: {
                'Authorization': `Bearer ${token}`,
              },
            });
            const passKeyData = await passKeyResponse.json();
  
            if (passKeyData.success) {
              
            } else {
              console.error('Error obteniendo el PASS_KEY:', passKeyData.error);
            }
          } else {
            console.error('Error obteniendo la API Key:', data.error);
          }
        } catch (error) {

        }
      } else {
        
      }
    };
  
    fetchApiKeyAndPassKey();
  }, [assistantId]);
  
  useEffect(() => {
    // Función para limpiar localStorage al iniciar la app
    const clearLocalStorage = () => {
      localStorage.removeItem(`WHATSAPP_PHONE_NUMBER_${assistantId}`);
      localStorage.removeItem(`WHATSAPP_PHONE_NUMBER_ID_${assistantId}`);
      localStorage.removeItem(`WABA_ID_${assistantId}`);
    };

    clearLocalStorage(); // Limpiar los datos al cargar la app

    const fetchPhoneNumber = async () => {
      try {
        const assistantRef = doc(db, 'assistants', assistantId);
        const assistantDoc = await getDoc(assistantRef);
  
        if (assistantDoc.exists) {
          const data = assistantDoc.data();
          if (data.phone_number && data.phone_number_id) {
           
            setPhoneNumbers([{
              id: data.phone_number_id,
              phone_number_id: data.phone_number_id,
              phone_number: data.phone_number,
              waba_id: data.waba_id,
            }]);
            setSelectedPhoneNumber(data.phone_number_id);
          } else {
            
            setPhoneNumbers([]);
          }
        } else {
          
          await assistantRef.set({ phone_number_id: '', phone_number: '', waba_id: '' });
          setPhoneNumbers([]);
        }
      } catch (error) {
        console.error('Error obteniendo el número de WhatsApp:', error);
      }
    };
  
    fetchPhoneNumber();
  }, [assistantId]);

  const handlePhoneNumberChange = (e) => {
    setSelectedPhoneNumber(e.target.value);
  };

  // Función para manejar el envío del PIN
  const handleSubmitPin = () => {
    if (pin.length !== 6 || !/^\d{6}$/.test(pin)) {
      
      return;
    }
    if (isSubmitting) return; // Prevenir múltiples envíos
    setIsSubmitting(true); // Indicar que el envío está en curso


    // Obtener el número de WhatsApp seleccionado desde el estado
    const selectedNumber = phoneNumbers.find(num => num.phone_number_id === selectedPhoneNumber);

    if (!selectedNumber) {
     
      return;
    }

    const { phone_number_id, waba_id } = selectedNumber;

    // Enviar los datos al backend para registrar el número
    fetch('https://backend.thethingapp.com/register-whatsapp-number', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        phone_number_id,
        waba_id,
        assistantId,
        pin,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
        
            setIsSubmitting(false); // Resetear el estado de envío
          // Cerrar el modal y actualizar el estado según sea necesario
          setIsPinModalOpen(false);
          // Opcional: Actualizar el estado de phoneNumbers si es necesario
        } else {
          console.error('Error al registrar el número de WhatsApp:', data.error);
         
        }
      })
      .catch((error) => {
        console.error('Error en la solicitud de registro:', error);

      });
  };

  const handleDownloadInstructions = () => {
    // Prioridad: 1) texto editado, 2) instrucciones de OpenAI, 3) Firestore como fallback
    const text =
      isEditingInstructions && newInstructions
        ? newInstructions
        : assistantDetails?.instructions || assistantDetails?.userInstructions || '';
    if (!text) {
      toast.info('ℹ️ No hay instrucciones para descargar.');
      return;
    }
  
    // Crear un blob de tipo texto
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
  
    // Crear un nombre para el archivo: "instrucciones-nombreDelAssistant.txt"
    // Usamos assistantDetails.name si existe, de lo contrario "instrucciones.txt"
    const fileName = assistantDetails && assistantDetails.name 
      ? `Instrucciones-${assistantDetails.name}.txt`
      : "Instrucciones.txt";
  
    // Crear un elemento de ancla temporal para forzar la descarga
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  
    // Revocar el objeto URL para liberar memoria
    window.URL.revokeObjectURL(url);
  };
  

  const handleEditName = () => {
    setNewName(assistantDetails.name);
    setIsEditingName(true);
};

const handleSaveName = async () => {
  if (!assistantDetails) return;
  try {
    // 1) Actualiza en Firestore
    const assistantRef = doc(db, 'assistants', assistantId);
    await setDoc(
      assistantRef,
      { name: newName },
      { merge: true }
    );


   await updateAssistantName(assistantId, newName, localStorage.getItem('API_KEY') || '');

    // 2) Refrescar en el estado local
    setAssistantDetails(prev => ({
      ...prev,
      name: newName
    }));
    setIsEditingName(false);

  } catch (error) {
    console.error("Error al actualizar el nombre:", error);
  }
};


const handleCancelEditName = () => {
  setNewName(assistantDetails?.name || '');
  setIsEditingName(false);
};

useEffect(() => {
  const saveAssistantIdString = async () => {
    if (!assistantId) {
      console.error('assistantId is undefined or null.');
      return;
    }
    try {
      const user = auth.currentUser;
      if (!user) {
        console.error('User not authenticated.');
        return;
      }
      const userId = user.uid;

      const assistantRef = doc(db, 'assistants', assistantId);
      const assistantDoc = await getDoc(assistantRef);

      if (!assistantDoc.exists()) {
        await setDoc(
          assistantRef,
          { 
            assistantId: assistantId.toString(),
            ownerId: userId, // Agregar ownerId al crear el documento
            phone_number_id: '',
            phone_number: '',
            waba_id: '',
            createdAt: new Date().toISOString(),
          },
          { merge: true }
        );
        
      } else {
        if (!assistantDoc.data().ownerId) {
          await setDoc(
            assistantRef,
            { ownerId: userId }, // Actualizar ownerId si no existe
            { merge: true }
          );
          
        } else {
          
        }
      }
    } catch (error) {
      console.error('Error saving assistantId and ownerId:', error);
    }
  };

  saveAssistantIdString();
}, [assistantId]);


const handleDeletePhoneData = async () => {
  try {
    const assistantRef = doc(db, "assistants", assistantId);
    await updateDoc(assistantRef, {
      phone_number: deleteField(),
      phone_number_id: deleteField(),
      waba_id: deleteField(),
      facebookAccessToken: deleteField(),
      registration_status: deleteField()
    });
// Limpiar estados y localStorage si es necesario
    setPhoneNumbers([]);
    setSelectedPhoneNumber("");
    localStorage.removeItem(`WHATSAPP_PHONE_NUMBER_${assistantId}`);
    localStorage.removeItem(`WHATSAPP_PHONE_NUMBER_ID_${assistantId}`);
    localStorage.removeItem(`WABA_ID_${assistantId}`);
    toast.success('✔️ Datos del número desvinculados correctamente');
  } catch (error) {
    console.error("Error eliminando los datos del teléfono:", error);
  }
};

const handleDeleteAssistant = async () => {
  if (window.confirm('¿Estás seguro de que deseas eliminar este asistente? Esta acción no se puede deshacer.')) {
    try {
      // Eliminar el asistente en OpenAI
      await deleteAssistant(assistantId);
      

      // Eliminar el documento del asistente en Firestore
      const assistantRef = doc(db, 'assistants', assistantId);
      await deleteDoc(assistantRef);
      

  
      navigate('/'); // Redirige de nuevo a la página principal
    } catch (error) {
      console.error('Error eliminando el asistente:', error);
     
    }
  }
};

  
// utils/whatsappFormat.js
function parseWhatsappFormat (raw = '') {
  /* 1 · escapar HTML para no romper el DOM */
  const escape = (str) =>
    str.replace(/[&<>"]/g, (c) =>
      ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

  let text = escape(raw.trim());

  /* ----- ENCABEZADOS (#  ##  ###) ------------------------- */
  text = text
    .replace(/^###\s+(.+)$/gm, '<h3>$1</h3>')
    .replace(/^##\s+(.+)$/gm,  '<h2>$1</h2>')
    .replace(/^#\s+(.+)$/gm,   '<h1>$1</h1>');

  /* ----- LISTAS ------------------------------------------- */
  // bullets  - item   * item
  text = text.replace(/^\s*[-*]\s+(.+)$/gm, '<li>$1</li>');
  // números  1. item
  text = text.replace(/^\s*\d+\.\s+(.+)$/gm, '<li>$1</li>');
  // envolver bloques consecutivos de <li>…</li> en <ul>/<ol>
  text = text.replace(/(<li>[\s\S]+?<\/li>)/g, (m)=>
          m.includes('</li><li>') ? '<ul>'+m+'</ul>' : m);

/* NEGRITA:  *texto*   ó   **texto**  */
text = text.replace(
  /(^|[^*])\*{1,2}([^*\s][^*]*?)\*{1,2}(?!\*)/g,
  '$1<strong>$2</strong>'
);

/* CURSIVA:  _texto_   ó   __texto__ */
text = text.replace(
  /(^|[^_])_{1,2}([^_\s][^_]*?)_{1,2}(?!_)/g,
  '$1<em>$2</em>'
);


  return text.replace(/\n/g,'<br>');
}

  useEffect(() => {
    // Reiniciar los estados de edición al cambiar de asistente
    setIsEditingInstructions(false);
    setNewInstructions('');
    setIsEditingName(false);
    setNewName('');
    
    // También puedes limpiar otros estados si es necesario
  }, [assistantId]);
  

  useEffect(() => {
    const initFacebookSdk = () => {
      if (!window.FB || typeof window.FB.init !== 'function') return;
      try {
        window.FB.init({
          appId: '1067207251796817',
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v21.0',
        });

        window.FBReady = true;
        setIsFacebookSDKReady(true);
      } catch (e) {
        console.error('Error inicializando Facebook SDK:', e);
      }
    };

    window.fbAsyncInit = function() {
      initFacebookSdk();
    };

    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    if (window.FB && typeof window.FB.init === 'function') {
      initFacebookSdk();
    }

    const handleFacebookMessage = (event) => {
      if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") {
        return;
      }
      try {
        const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          // Verificar si el flujo de registro está completo
          if (data.event === 'FINISH') {
            const { phone_number_id, waba_id } = data.data;
           
            handleWhatsAppSignupComplete(phone_number_id, waba_id);
            // Guardar los IDs localmente o enviarlos al backend
          } else if (data.event === 'CANCEL') {
            const { current_step } = data.data;
            console.warn("Cancel at ", current_step);
          } else if (data.event === 'ERROR') {
            const { error_message } = data.data;
            console.error("Error ", error_message);
          }
        }
      } catch (e) {
       
      }
    };

    window.addEventListener('message', handleFacebookMessage);

    return () => {
      window.removeEventListener('message', handleFacebookMessage);
    };
  }, []);

  // Función de callback después del inicio de sesión en Facebook
  const fbLoginCallback = (response) => {
    console.log('fbLoginCallback response completo:', response);
    
    if (response.authResponse) {
      const code = response.authResponse.code;
      
      // Verificar si vienen datos de setup (phone_number_id, waba_id)
      const setupData = response.authResponse.setup || response.setup;
      console.log('Setup data:', setupData);
      
      // Envía este código y el assistantId a tu backend para intercambiarlo por un access token
      fetch('https://backend.thethingapp.com/exchange-code', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          code,
          assistantId,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            // Si el backend devuelve wabaData y aún no se procesó el signup
            if (data.wabaData && data.wabaData.phone_number_id && data.wabaData.waba_id && !signupProcessedRef.current) {
              console.log('WABA data recibida del backend:', data.wabaData);
              signupProcessedRef.current = true;
              handleWhatsAppSignupComplete(
                data.wabaData.phone_number_id,
                data.wabaData.waba_id,
                assistantId
              );
            } else if (signupProcessedRef.current) {
              console.log('Signup ya procesado por event listener, omitiendo duplicado.');
            } else {
              console.log('No se recibió wabaData del backend. Esperando evento WA_EMBEDDED_SIGNUP...');
            }
          } else {
            console.error('Error al intercambiar el código:', data.error);
          }
        })
        .catch((error) => {
          console.error('Error en la solicitud de intercambio de código:', error);
        });
    } else {
      console.error('No authResponse en fbLoginCallback:', response);
    }
  };

  const startWhatsAppFlow = () => {
    if (window.FBReady) {
      FB.login((response) => {
        if (response.authResponse) {
          
          startEmbeddedSignUpFlow(response.authResponse.accessToken);
        } else {
         
        }
      }, { scope: 'whatsapp_business_management,whatsapp_business_messaging', display: 'popup' });
    } else {
      console.error('El SDK de Facebook aún no está listo.');
    }
  };

  // Inicia el flujo de registro embebido de WhatsApp
  const startEmbeddedSignUpFlow = (accessToken) => {
    FB.ui({
      method: 'business_embedded_signup',
      access_token: accessToken,
      business_id: '808344569245976',  // Reemplaza con tu Business ID de Facebook
      redirect_uri: 'https://platform.thethingapp.com/',  // Reemplaza con tu URI de redirección
    }, (response) => {
      if (response && !response.error) {
        
      } else {
        console.error('Error en el flujo de registro', response.error);
      }
    });
  };

  const launchWhatsAppSignup = () => {
    if (window.FBReady && window.FB) {
      isCoexistenceSignupRef.current = false;
      signupProcessedRef.current = false;
      window.FB.login(fbLoginCallback, {
        config_id: '879398050834125', // Config para Cloud API normal
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          feature: 'whatsapp_embedded_signup',
          sessionInfoVersion: 3,
        }
      });
    } else {
      toast.info('ℹ️ Cargando Facebook SDK, probá de nuevo en unos segundos.');
    }
  };

  const launchWhatsAppCoexistenceSignup = () => {
    if (window.FBReady && window.FB) {
      isCoexistenceSignupRef.current = true;
      signupProcessedRef.current = false;
      window.FB.login(fbLoginCallback, {
        config_id: '3512715898877449',
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          featureType: 'whatsapp_business_app_onboarding',
          sessionInfoVersion: 3,
          version: 'v3',
        }
      });
    } else {
      toast.info('ℹ️ Cargando Facebook SDK, probá de nuevo en unos segundos.');
    }
  };

  // Función para manejar el registro de WhatsApp Business completo
  const axios = require('axios');

  // ... (tu código existente)
  
// La función handleWhatsAppSignupComplete actualizada
const handleWhatsAppSignupComplete = async (phone_number_id, waba_id, assistantIdParam) => {
  const assistantIdToUse = assistantIdParam || assistantId;
  try {
    // Primero, guarda los detalles del número de WhatsApp en Firebase como lo estás haciendo actualmente
    const response = await fetch('https://backend.thethingapp.com/get-whatsapp-number', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        phone_number_id, 
        waba_id, 
        assistantId: assistantIdToUse,
      }),
    });
    const data = await response.json();
    


    if (data.success) {
     
      



      // Para coexistencia NO se necesita PIN (el número ya está registrado en WA Business App)
      if (isCoexistenceSignupRef.current) {
        console.log('Coexistencia: omitiendo PIN, el número ya está registrado.');
      } else {
        // Abrir el modal para ingresar el PIN (solo para Cloud API)
        handleOpenPinModal();
      }

      // Guardar en localStorage temporalmente
      localStorage.setItem(`WHATSAPP_PHONE_NUMBER_${assistantId}`, data.phone_number);
      localStorage.setItem(`WHATSAPP_PHONE_NUMBER_ID_${assistantId}`, phone_number_id);
      localStorage.setItem(`WABA_ID_${assistantId}`, waba_id);

     

      setPhoneNumbers([{
        id: phone_number_id,
        phone_number_id,
        phone_number: data.phone_number,
        waba_id,
      }]);
      // Añade assistantId como parámetro al llamar a las funciones
await subscribeAppToWABAWebhooks(waba_id, assistantId);
await checkWABASubscription(waba_id, assistantId);

      setSelectedPhoneNumber(phone_number_id); // Seleccionar automáticamente el número
    } else {
      console.error('Error guardando el número de WhatsApp:', data.error);
    }
  } catch (error) {
    console.error('Error en la solicitud:', error);
  }
};

// Función para suscribirse al webhook de la WABA
const subscribeAppToWABAWebhooks = async (wabaId, assistantId) => {
  try {
    const response = await fetch('https://backend.thethingapp.com/subscribe-waba-webhook', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ wabaId, assistantId }),
    });
    const data = await response.json();
    

    if (data.success) {
      
    } else {
      
    }
  } catch (error) {
    
  }
};

// Función para verificar la suscripción al webhook de la WABA
// Function to check WABA subscription
const checkWABASubscription = async (wabaId, assistantId) => {
  try {
  
    const response = await fetch(`https://backend.thethingapp.com/check-waba-subscription?wabaId=${wabaId}&assistantId=${assistantId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    const data = await response.json();

    
  } catch (error) {
    console.error('Error al verificar la suscripción al webhook de la WABA:', error);
  }
};


  // Este efecto maneja la escucha de los eventos de finalización del registro embebido
  useEffect(() => {
    const handleMessageEvent = (event) => {
      if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") {
        return;
      }
      console.log('Mensaje recibido de Facebook:', event.origin, event.data);
      try {
        const data = JSON.parse(event.data);
        console.log('Datos parseados de Facebook:', data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          console.log('WA_EMBEDDED_SIGNUP evento detectado:', data.event, data.data);
          if (data.event === 'FINISH' || data.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING') {
            const { phone_number_id, waba_id } = data.data;
            console.log('FINISH - phone_number_id:', phone_number_id, 'waba_id:', waba_id);
            if (!signupProcessedRef.current) {
              signupProcessedRef.current = true;
              handleWhatsAppSignupComplete(phone_number_id, waba_id, assistantId);
            } else {
              console.log('Signup ya procesado, omitiendo duplicado desde event listener.');
            }
          } else if (data.event === 'CANCEL') {
            const { current_step } = data.data;
            console.warn("Cancel at ", current_step);
            // Puedes manejar el estado de cancelación aquí si lo deseas
          } else if (data.event === 'ERROR') {
            const { error_message } = data.data;
            console.error("Error ", error_message);
            // Puedes manejar errores aquí si lo deseas
          }
        }
      } catch (e) {
        console.log('Mensaje no-JSON de Facebook:', event.data);
      }
    };

    window.addEventListener('message', handleMessageEvent);

    // Cleanup para remover el event listener cuando el componente se desmonta
    return () => {
      window.removeEventListener('message', handleMessageEvent);
    };
  }, [assistantId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Carga las instrucciones (y demás detalles) desde OpenAI
        const details = await getAssistantDetails(assistantId);
        // details.instructions -> Contiene las instrucciones en OpenAI
        // details.name -> Nombre del asistente en OpenAI (lo podemos ignorar si preferimos solo Firestore)

        // Guardo en mi estado las instrucciones de OpenAI (bajo 'instructions')
        // y pondré un "name" temporal (que luego sobreescribiré con Firestore).
        setAssistantDetails({
          ...details, // Deja todo lo que OpenAI provea
          instructions: details.instructions, // ya viene
          name: details.name || '' // lo pisaré abajo con Firestore
        });

        // Llamar a Firestore para obtener SOLO el nombre
        const assistantRef = doc(db, 'assistants', assistantId);
        const assistantDoc = await getDoc(assistantRef);
        if (assistantDoc.exists()) {
          const data = assistantDoc.data();
          const storedVectorStoreId = data.vectorStoreId || '';
          // Solo pisamos "name" con el de Firestore
          setAssistantDetails(prev => ({
            ...prev,
            name: data.name || prev.name
          }));

          if (storedVectorStoreId) {
            setSelectedKnowledgeBase(storedVectorStoreId);
          }
        }

        // Verificar si "file_search" está habilitado
        if (details.tools && details.tools.some(tool => tool.type === 'file_search')) {
          setIsKnowledgeBaseEnabled(true);
          if (details.tool_resources &&
              details.tool_resources.file_search &&
              details.tool_resources.file_search.vector_store_ids.length > 0) {
            setSelectedKnowledgeBase(details.tool_resources.file_search.vector_store_ids[0]);
          }
        } else {
          setIsKnowledgeBaseEnabled(false);
        }

      } catch (error) {
        console.error("Error obteniendo detalles del asistente en OpenAI:", error);
      }
    };

    if (assistantId) {
      fetchData();
    }
  }, [assistantId]);

  useEffect(() => {
    const fetchAssistantDetails = async () => {
      const details = await getAssistantDetails(assistantId, apiKey);
      setAssistantDetails(details);

        // Obtener las instrucciones del usuario desde Firestore
  const assistantDocRef = doc(db, 'assistants', assistantId);
  const assistantDoc = await getDoc(assistantDocRef);

  if (assistantDoc.exists()) {
    const assistantData = assistantDoc.data();
    setAssistantDetails({
      ...details,
      userInstructions: assistantData.instructions, // Instrucciones del usuario
      name: assistantData.name, // Asegurarse de usar el nombre correcto
    });

    if (assistantData.vectorStoreId) {
      setSelectedKnowledgeBase(assistantData.vectorStoreId);
    }
  } else {
    // Si no se encuentran las instrucciones en Firestore
    setAssistantDetails({
      ...details,
      userInstructions: '', // O manejarlo según sea necesario
    });
  }

            // Establece el nombre del asistente en el contexto
            setAssistantName(details.name);
  
      // Verificar si file_search ya está habilitado en OpenAI
      if (details.tools && details.tools.some(tool => tool.type === 'file_search')) {
        setIsKnowledgeBaseEnabled(true); // Sincronizar el estado del interruptor
        if (details.tool_resources && details.tool_resources.file_search.vector_store_ids.length > 0) {
          setSelectedKnowledgeBase(details.tool_resources.file_search.vector_store_ids[0]);
        }
      } else {
        setIsKnowledgeBaseEnabled(false); // Desactivar el interruptor si file_search no está habilitado
      }
    };
  
    const fetchVectorStores = async () => {
      if (!currentUser) {
        console.error('Usuario no autenticado.');
        setVectorStores([]);
        return;
      }
      const vectorStoresData = await getAllVectorStores(currentUser.uid); // Pasar currentUser.uid
      setVectorStores(vectorStoresData);
    };
  
    if (apiKey) { // Asegurarse de que apiKey está disponible
      fetchAssistantDetails();
      fetchVectorStores();
    }
  }, [assistantId, apiKey, setAssistantName, currentUser]);
const handleSendMessage = async () => {
  if (!input.trim()) return;

  const clientTs = Date.now();
  // 2.1 · Mensaje optimista del usuario
  setMessages(prev => [
    ...prev,
    { role: 'user', content: input, createdAt: clientTs, messageType: 'text' }
  ]);

  setInput('');
  setIsLoading(true);

  try {
    // Llamada al chat-proxy
    const res = await fetch('https://backend.thethingapp.com/api/chat-proxy', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
     body: JSON.stringify({
         assistantId,
       threadId,
       message: input,
       skipAttachmentsInHistory: true,    // ← nuevo
       channel: 'preview'
     }),
    });
    if (!res.ok) throw new Error((await res.json()).error || 'Error al procesar mensaje');

    const { reply, attachments = [], threadId: newThreadId } = await res.json();
    if (!threadId && newThreadId) setThreadId(newThreadId);

    const ts = Date.now();
    // 2.2 · Bubble de texto del assistant
    const assistantBubble = {
      role: 'assistant',
      content: reply,
      createdAt: ts,
      messageType: 'text'
    };

    // 2.3 · Burbujas de attachments (image, pdf, office, video, audio)
    const attBubbles = attachments.map((a, i) => ({
      role: 'assistant',
      content: a.url,
      createdAt: ts + i + 1,
      messageType: a.type,
      caption: a.caption || ''
    }));

    // 2.4 · Guardar en Firestore / tu store si lo necesitas...
    //    (puedes reutilizar tu lógica actual de setDoc/updateDoc aquí)

    // 2.5 · Reflejar TODO en UI
    setMessages(prev => [
      ...prev,
      assistantBubble,
      ...attBubbles
    ]);

  } catch (err) {
    console.error(err);
    setMessages(prev => [
      ...prev,
      { role: 'assistant', content: 'Hubo un error al procesar tu mensaje.', messageType: 'text' }
    ]);
  } finally {
    setIsLoading(false);
  }
};


const formatMessageContent = (content) => parseWhatsappFormat(content);

  const handleBackToAgents = () => {
    navigate('/');
  };

  const handleTryChatBubble = () => {
    navigate(`/bubble/${assistantId}`);
  };

  const handleKnowledgeBaseToggle = async (e) => {
    const isEnabled = e.target.checked;
    setIsKnowledgeBaseEnabled(isEnabled);
    
    try {
      if (isEnabled) {
        // Habilitar file_search en OpenAI
        await enableFileSearchForAssistant(assistantId, apiKey);

        if (selectedKnowledgeBase) {
          await setDoc(doc(db, 'assistants', assistantId), { vectorStoreId: selectedKnowledgeBase }, { merge: true });
        }

      } else {
        // Deshabilitar file_search en OpenAI
        await disableFileSearchForAssistant(assistantId, apiKey);
        setSelectedKnowledgeBase(''); // Limpiar la selección de base de conocimiento

        await setDoc(
          doc(db, 'assistants', assistantId),
          { vectorStoreId: deleteField() },
          { merge: true }
        );

      }
    } catch (error) {
      console.error('Error actualizando file search:', error);

    }
  };

  const handleKnowledgeBaseChange = async (e) => {
    const vectorStoreId = e.target.value;
    setSelectedKnowledgeBase(vectorStoreId);

    if (vectorStoreId && assistantDetails) {
      try {
        await associateVectorStoreToAssistant(assistantId, vectorStoreId, apiKey);
        await setDoc(doc(db, 'assistants', assistantId), { vectorStoreId }, { merge: true });
      
      } catch (error) {
        console.error('Error al asociar la base de conocimiento:', error);
       
      }
    }
  };



/* ─── Al entrar en modo edición ────────────────────────── */
const handleEditInstructions = () => {
  if (!assistantDetails) return;

  setNewInstructions(assistantDetails.instructions || '');
  setIsEditingInstructions(true);

  /* NUEVO ─────────────── */
  setDirtyInstructions(true);   // ← marca “hay cambios” aun sin teclear
};


/* ─── Guardar ─────────────────────────────────────────────── */
const handleSaveInstructions = async () => {
  setIsSavingInstructions(true);
  try {
    // convierto a texto plano antes de enviarlo (sacá parse si ya guardás markdown)
 await updateAssistantInstructions(assistantId, newInstructions);
  setAssistantDetails(prev => ({ ...prev, instructions: newInstructions }));
    setIsEditingInstructions(false);
    setDirtyInstructions(false);
  } catch (err) {
    console.error(err);
  } finally {
    setIsSavingInstructions(false);
  }
};
  

useEffect(() => {
  const handleBeforeUnload = (e) => {
    if (!dirtyInstructions) return;
    e.preventDefault();      // necesario para la mayoría de navegadores
    e.returnValue = '';      // Chrome/Edge → muestra diálogo nativo
  };
  window.addEventListener('beforeunload', handleBeforeUnload);
  return () => window.removeEventListener('beforeunload', handleBeforeUnload);
}, [dirtyInstructions]);

  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        handleCloseModal();
      }
    };
  
    if (isModalOpen) {
      window.addEventListener('keydown', handleEscKey);
    }
  
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [isModalOpen]);
  


  

  const handleCancelEdit = () => {
    setNewInstructions(assistantDetails?.instructions || '');
    setIsEditingInstructions(false);
    setDirtyInstructions(false);
    
  };
  
  // Funciones para manejar el modal
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const sessionInfoListener = (event) => {
    if (event.origin == null || !event.origin.endsWith("facebook.com")) {
      return;
    }
  
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'WA_EMBEDDED_SIGNUP') {
        if (data.event === 'FINISH') {
          const { phone_number_id, waba_id } = data.data;
          
          handleWhatsAppSignupComplete(phone_number_id, waba_id);
        } else if (data.event === 'ERROR') {
          console.error("Error:", data.data.error_message);
        } else if (data.event === 'CANCEL') {
          console.warn("Canceled at step:", data.data.current_step);
        }
      }
    } catch (error) {
      
    }
  };
  
  useEffect(() => {
    window.addEventListener('message', sessionInfoListener);
    return () => {
      window.removeEventListener('message', sessionInfoListener);
    };
  }, []);



  const handleCopyScript = () => {
    if (!assistantId) {
      console.error('assistantId faltante:', assistantId);
      return;
    }
  
    const scriptContent = `
  <!-- React -->
  <script src="https://unpkg.com/react@17/umd/react.production.min.js" crossorigin></script>
  
  <!-- ReactDOM -->
  <script src="https://unpkg.com/react-dom@17/umd/react-dom.production.min.js" crossorigin></script>
  
  <!-- Tu Bundle -->
  <script src="https://platform.thethingapp.com/dist/chat-bubble.bundle.js"></script>
  
  <!-- Script para Inicializar el Widget -->
  <script type="text/javascript">
    (function(d, t) {
      var v = d.createElement(t), s = d.getElementsByTagName(t)[0];
      v.onload = function() {
        if (window.ChatBubbleWidget && typeof window.ChatBubbleWidget.load === 'function') {
          window.ChatBubbleWidget.load({
            assistantId: '${assistantId}'
          });
        }
      };
      v.src = "https://platform.thethingapp.com/dist/chat-bubble.bundle.js";
      v.type = "text/javascript";
      s.parentNode.insertBefore(v, s);
    })(document, 'script');
  </script>
    `;
  
    navigator.clipboard.writeText(scriptContent)
      .then(() => {
        toast.success('✔️ El código se copió correctamente');
      })
      .catch((err) => {
        console.error('Error al copiar el script:', err);
      });
  };
  
  const handleCopyCustomScript = () => {
    if (!assistantId) {
      console.error('assistantId faltante');
      return;
    }
  
    const customStyles = {
      headerColor,
      bubbleButtonColor,
      messageUserColor,
      messageAssistantColor,
      bubbleButtonImage,
      useBackgroundImage,
      backgroundColor,
      includeWaves: false,
      chatIconButtonColor,
      chatIconColor,
      messageContentColor,
      bubbleButtonSize
    };
  
    const scriptContent = `
  <!-- React -->
  <script src="https://unpkg.com/react@17/umd/react.production.min.js" crossorigin></script>
  
  <!-- ReactDOM -->
  <script src="https://unpkg.com/react-dom@17/umd/react-dom.production.min.js" crossorigin></script>
  
  <!-- Tu Bundle -->
  <script src="https://platform.thethingapp.com/dist/chat-bubble.bundle.js"></script>
  
  <!-- Script para Inicializar el Widget -->
  <script type="text/javascript">
    (function(d, t) {
      var v = d.createElement(t), s = d.getElementsByTagName(t)[0];
      v.onload = function() {
        if (window.ChatBubbleWidget && typeof window.ChatBubbleWidget.load === 'function') {
          window.ChatBubbleWidget.load({
            assistantId: '${assistantId}',
            customStyles: ${JSON.stringify(customStyles)},
            showChatIconButton: ${showChatIconButton}
          });
        }
      };
      v.src = "https://platform.thethingapp.com/dist/chat-bubble.bundle.js";
      v.type = "text/javascript";
      s.parentNode.insertBefore(v, s);
    })(document, 'script');
  </script>
    `;
  
    navigator.clipboard.writeText(scriptContent)
      .then(() => {
        toast.success('✔️ El código personalizado se copió correctamente');
      })
      .catch((err) => {
        console.error('Error al copiar el script personalizado:', err);
      });
  };


  
  
  if (!assistantDetails) return         <div
  className="loading"
  style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 'calc(100vh - 100px)', 
    fontSize: 'xx-large',
  }}
>
  Cargando...
</div>;

  return (
    <div className='assistant-chat-page'>
      <div className="assistant-page-container">
      <div className="chat-section-container">
        <div className="assistant-editor-container">

        <div className='name-display-agents'>
  {isEditingName ? (
    <div className='name-editor'>
      <input
        type="text"
        value={newName}
        onChange={(e) => setNewName(e.target.value)}
        className="new-name-input"
      />
      <button onClick={handleSaveName} className="save-newname-button">Guardar</button>
    </div>
  ) : (
    <h2 className='editor-agente' onClick={handleEditName}>
      Editar {assistantDetails.name}
    </h2>
  )}
</div>


          <div className="toggle-container">
            <label className="activar-base">Activar la base de datos</label>       
            <label className="switch"> 
              <input 
                type="checkbox" 
                checked={isKnowledgeBaseEnabled} 
                onChange={handleKnowledgeBaseToggle} 
              />
              <span className="slider-training round"></span>
            </label>
          </div>

{isKnowledgeBaseEnabled && (
  <div className='base-selector'>
    <label className="activar-base">Elegir base de datos</label>

    {/* ⬇️ agrupamos el select y el nuevo botón en la misma línea */}
    <div style={{ display:'flex', gap:'.5rem', alignItems:'center', }}>
      <select
        className='base-selector'
        value={selectedKnowledgeBase}
        onChange={handleKnowledgeBaseChange}
      >
        <option value="">Seleccionar una base</option>
        {vectorStores.map(vs => (
          <option key={vs.id} value={vs.id}>{vs.name}</option>
        ))}
      </select>

      {/* 🔹 botoncito “ir a la KB” */}
      <button
        type="button"
        title="Abrir esta base de conocimiento"
        disabled={!selectedKnowledgeBase}
        onClick={() => {
          /* El modal de KB sólo vive en MisAsistentes.
             Le mandamos el ID para que se auto-abra. */
          navigate('/', { state:{ openKnowledgeBaseId: selectedKnowledgeBase } });
        }}
        style={{
          border:'none',
          background:'transparent',
          cursor: selectedKnowledgeBase ? 'pointer' : 'not-allowed',
          fontSize:'1.1em',              // mismo tamaño que el texto
          lineHeight:1,
          padding:0
        }}
      >
<FontAwesomeIcon className="ir-a-base-conocimiento" icon={faUpRightFromSquare} />

      </button>
    </div>
  </div>
)}


 {/* *** NUEVO *** Botón para crear carpeta y subir imágenes */}
 <div className="btns-files">
  <button 
    onClick={handleCreateFolderButtonClick} 
    className="subir-base-imagenes"
  >
   Agregar archivos a la galeria
  </button>
{/* Spinner de carga mientras isUploadingFiles === true */}
{isUploadingFiles && (
  <div className="spinner-container-files">
    {/* Puedes usar tu propia clase CSS para animar */}
    <div className="spinner-files" />
  </div>
)}

<input
  type="file"
  multiple
  ref={imageFileInputRef}
  onChange={handleFilesSelected}
  style={{ display: 'none' }}
  accept="
    image/jpeg,image/png,image/webp,
    video/mp4,video/3gpp,
    audio/aac,audio/mp4,audio/mpeg,audio/amr,audio/ogg,audio/opus,
    application/pdf,
    .txt,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,
    application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,
    application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
    application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,
    text/plain
  "
/>


  {/* Siempre muestro el icono de carpeta */}
  <button 
    className="carpeta-galeria-button" 
    onClick={() => setIsGalleryOpen(true)}
  >
    <FontAwesomeIcon icon={faFolderOpen} />
  </button>
</div>


{/* ▼  SECCIÓN COMPLETA CON LOS TRES CAMBIOS  ▼ */}
<div
  className={`instrucciones-container ${isFullScreenInstructions ? 'fullscreen' : ''}`}
>
  {/* header con botón de pantalla completa */}
  <div className="instructions-header">
  <button
  className="fullscreen-toggle-button"
  title={isFullScreenInstructions ? 'Salir de pantalla completa'
                                   : 'Pantalla completa'}
  onClick={() => {
    /* ⇢ ENTRAR en fullscreen */
    if (!isFullScreenInstructions) {
      if (!isEditingInstructions) {
        setNewInstructions(assistantDetails?.instructions || '');
        setIsEditingInstructions(true);
      }
      setIsFullScreenInstructions(true);
      return;
    }

    /* ⇢ SALIR de fullscreen */
    if (confirmLeave()) {
      /* 1 · cerrar fullscreen ----------- */
      setIsFullScreenInstructions(false);

      /* 2 · cancelar edición ------------- */
      setIsEditingInstructions(false);

      /* 3 · restaurar texto -------------- */
      setNewInstructions(assistantDetails?.instructions || '');

      /* 4 · reset flag de cambios -------- */
      setDirtyInstructions(false);
    }
  }}
>
  <FontAwesomeIcon
    icon={isFullScreenInstructions ? faCompressArrowsAlt : faExpandArrowsAlt}
  />
</button>

  </div>

  {/* textarea */}
{/* textarea en vez de contentEditable */}
{isEditingInstructions ? (
  <textarea
    className="instructions-textarea editable"
    value={newInstructions}
    onChange={e => {
      setNewInstructions(e.target.value);
      setDirtyInstructions(e.target.value !== (assistantDetails?.instructions || ''));
    }}
    rows={15}           /* ajusta a gusto */
  />
) : (
  <div
    className="instructions-textarea readonly"
    dangerouslySetInnerHTML={{
      __html: parseWhatsappFormat(assistantDetails.instructions || '')
    }}
  />
)}


  {/* botón Guardar visible sólo en fullscreen */}
  {isFullScreenInstructions && isEditingInstructions && (
    <button
  className="save-instructions-button fullscreen-save"
  onClick={handleSaveInstructions}
  disabled={isSavingInstructions}
>
  {isSavingInstructions ? <span className="spinner-saving" /> : 'GUARDAR'}
</button>
  )}
</div>

{/* footer con subir / descargar */}
<div className="instructions-footer">
  <button
    onClick={handleUploadInstructionsButton}
    className="upload-instructions-button"
    title="Subir instrucciones"
  >
    <FontAwesomeIcon icon={faUpload} />
    <input
      type="file"
      accept=".txt,.md,.html,.docx"
      style={{ display: 'none' }}
      ref={instructionsFileInputRef}
      onChange={handleInstructionsUpload}
    />
  </button>

  <button
    onClick={handleDownloadInstructions}
    className="download-instructions-button"
    title="Descargar instrucciones"
  >
    <FontAwesomeIcon icon={faDownload} />
  </button>
</div>




          {/* Sección de WhatsApp Business */}
          <div className='whatsapp-business'>
             {/* Mostrar el select solo si hay números disponibles */}
             {phoneNumbers && phoneNumbers.length > 0 && (
  <div className="select-and-button">
    <label className="label-number">Número vinculado:</label>
    <select className="number-select" value={selectedPhoneNumber} onChange={handlePhoneNumberChange}>
      {phoneNumbers.map((number) => (
        <option key={number.id} value={number.phone_number_id}>
          {number.phone_number}
        </option>
      ))}
    </select>
    {/* Botón de eliminación del teléfono */}
    <button
      className="delete-phone-button"
      onClick={() => {
        if (
          window.confirm(
            "¿Estás seguro de que deseas desvincular este número del asistente?"
          )
        ) {
          handleDeletePhoneData();
        }
      }}
      title="Desvincular número"
    >
      x
    </button>
  </div>
)}

          </div>

          {/* Modal */}
          {isModalOpen && (
  <div className="modal-overlay">
    <div className="modal-implementacion" ref={modalRef} tabIndex={-1}>
      <button className="close-button-imp" onClick={handleCloseModal}> x</button>
      <h2 className='implementacion-h2'>Implementación</h2>
      <p className="destino">Seleccione un destino:</p>

      {/* Pestañas */}
      <div className="tabs-container">
        <button
          className={`tab ${activeTab === 'plataformas' ? 'active' : ''}`}
          onClick={() => setActiveTab('plataformas')}
        >
          <img src={require('../assets/iconos-implementacion.png')} alt="Iconos" className="tab-icon" />
        </button>
        <button
          className={`tab ${activeTab === 'codigo' ? 'active' : ''}`}
          onClick={() => setActiveTab('codigo')}
        >
           <img src={require('../assets/codigo-icon.png')} alt="Icon" className="tab-icon" />
          Código
        </button>
        <button
          className={`tab ${activeTab === 'customizar' ? 'active' : ''}`}
          onClick={() => setActiveTab('customizar')}
        >
        <img src={require('../assets/customizar-icon.png')} alt="Icon" className="tab-icon" />
          Customizar
        </button>
      </div>

{/* Contenido de las Pestañas */}
<div className="tab-content">
  {activeTab === 'plataformas' && (
    <div className="platform-buttons">
      <button className="platform-button-whatsapp" onClick={() => setActivePlatform('whatsapp')}>
        <img src={require('../assets/whatsapp-icon.png')} alt="WhatsApp Icon" className="tab-icon" /> 
        WhatsApp
      </button>

  

  <button className="platform-button disabled-button">
    <img src={require('../assets/instagram-icon.png')} alt="Instagram Icon" className="tab-icon" />
    Instagram
  </button>

  <button className="platform-button disabled-button">
    <img src={require('../assets/messenger-icon.png')} alt="Messenger Icon" className="tab-icon" />
    Messenger
  </button>
</div>

        )}

  {/* Aquí está el ajuste necesario */}
  {activeTab === 'plataformas' && activePlatform === 'whatsapp' && (
    <div className='whatsapp-business'>
      <button className='conect-whatsapp-button' onClick={launchWhatsAppSignup}>
        Conectar WhatsApp Cloud API
      </button>
      <button className='conect-whatsapp-button' onClick={launchWhatsAppCoexistenceSignup}>
        Conectar con Coexistencia
      </button>

{/* Modal para ingresar el PIN */}
{isPinModalOpen && (
  <div className="modal-overlay">
  <div className="modal-pin" ref={modalRef} tabIndex={-1}>
    <button className="close-button" onClick={handleClosePinModal}>X</button>
    <h2 className="modal-title">Ingresa un PIN de 6 dígitos</h2>
    <p className="modal-subtitle">para la autenticación en dos pasos</p>
    
    <input 
      type="text" 
      value={pin} 
      onChange={(e) => setPin(e.target.value)} 
      placeholder="PIN de 6 dígitos" 
      maxLength={6}
      pattern="\d{6}"
      className="pin-input"
    />
    <p className="modal-text">*En cualquier intento de registrar tu número de teléfono en WhatsApp, se solicitará el PIN de seis dígitos que creaste. Si lo olvidas o lo pierdes, puedes desactivar la verificación en dos pasos o cambiar el PIN.</p>
    <div className="modal-buttons">
      <button className='submit-pin-button' onClick={handleSubmitPin} disabled={isSubmitting}>
      {isSubmitting ? 'Enviando...' : 'Enviar Pin'}</button>
      <button className='cancel-pin-button' onClick={handleClosePinModal}>Cancelar</button>
    </div>
  </div>
</div>

)}

    </div>
  )}

  {activeTab === 'codigo' && (
          <>
          <div className="tab-content non-social-tab-content">
            <pre className='code-script'>
              {`
<!-- React -->
<script src="https://unpkg.com/react@17/umd/react.production.min.js" crossorigin></script>

<!-- ReactDOM -->
<script src="https://unpkg.com/react-dom@17/umd/react-dom.production.min.js" crossorigin></script>

<!-- Tu Bundle -->
<script src="https://platform.thethingapp.com/dist/chat-bubble.bundle.js"></script>

        <!-- Script para Inicializar el Widget -->
        <script type="text/javascript">
          (function(d, t) {
            var v = d.createElement(t), s = d.getElementsByTagName(t)[0];
            v.onload = function() {
        if (window.ChatBubbleWidget && typeof window.ChatBubbleWidget.load === 'function') {
          window.ChatBubbleWidget.load({
            assistantId: '${assistantId}'
          });
              } 
            };
            v.src = "https://platform.thethingapp.com/dist/chat-bubble.bundle.js";
            v.type = "text/javascript";
            s.parentNode.insertBefore(v, s);
          })(document, 'script');
        </script> 
              `}
            </pre>
    <div className="button-container">
    <div className="additional-texts">
      <button className='copy-script' onClick={handleCopyScript}>Copiar código</button>
        <p className="info-text">*El código se pega en el header de tu sitio web</p>
       {/*  <p className="help-text">¿No está seguro de dónde implementar su chat web? <br></br><a href="#" target="_blank" rel="noopener noreferrer">Vea este tutorial.</a></p>*/}
      </div>
    </div>
    </div>
          </>
        )}

                {activeTab === 'customizar' && (
                            <div className="tab-content non-social-tab-content">
                  <div className="customization-section">
                    <div className="color-picker-container"> 
                    </div>

                    <div   className="options-preview-container">                     
<div   className="options-container">  
{/* Color del Encabezado del Chat */}
<div className="color-picker-container"> 
  <p className='form-personalizar'>Color del Encabezado del Chat:</p>
  <div className="color-picker-inline">
    <div
      className="color-swatch"
      style={{ backgroundColor: headerColor }}
      onClick={() => setIsHeaderColorPickerOpen(!isHeaderColorPickerOpen)}
    />
    <input
      className='input-custom'
      type="text"
      value={headerColor}
      onChange={(e) => setHeaderColor(e.target.value)}
    />
    {isHeaderColorPickerOpen && (
      <div className="color-picker-popover">
        <div className="color-picker-cover" onClick={() => setIsHeaderColorPickerOpen(false)} />
        <SketchPicker
          color={headerColor}
          onChangeComplete={(color) => setHeaderColor(color.hex)}
        />
      </div>
    )}
    
  </div>
  
</div>




                    {/* Color del Mensaje del Usuario */}
                    <div className="color-picker-container">
                      <p className='form-personalizar'>Color del Mensaje del Usuario:</p>
                      <div className="color-picker-inline">
                        <div
                          className="color-swatch"
                          style={{ backgroundColor: messageUserColor }}
                          onClick={() => setIsMessageUserColorPickerOpen(!isMessageUserColorPickerOpen)}
                        />
                        <input
                          type="text"
                          value={messageUserColor}
                          onChange={(e) => setMessageUserColor(e.target.value)}
                        />
                        {isMessageUserColorPickerOpen && (
                          <div className="color-picker-popover">
                            <div className="color-picker-cover" onClick={() => setIsMessageUserColorPickerOpen(false)} />
                            <SketchPicker
                              color={messageUserColor}
                              onChangeComplete={(color) => setMessageUserColor(color.hex)}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Color del Mensaje del Asistente */}
                    <div className="color-picker-container">
                      <p className='form-personalizar'>Color del Mensaje del Asistente:</p>
                      <div className="color-picker-inline">
                        <div
                          className="color-swatch"
                          style={{ backgroundColor: messageAssistantColor }}
                          onClick={() => setIsMessageAssistantColorPickerOpen(!isMessageAssistantColorPickerOpen)}
                        />
                        <input
                          type="text"
                          value={messageAssistantColor}
                          onChange={(e) => setMessageAssistantColor(e.target.value)}
                        />
                        {isMessageAssistantColorPickerOpen && (
                          <div className="color-picker-popover">
                            <div className="color-picker-cover" onClick={() => setIsMessageAssistantColorPickerOpen(false)} />
                            <SketchPicker
                              color={messageAssistantColor}
                              onChangeComplete={(color) => setMessageAssistantColor(color.hex)}
                            />
                          </div>
                        )}
                      </div>
                    </div>

{/* Color del Texto de los mensajes (message-content-bubble-frontend) */}
<div className="color-picker-container">
  <p className="form-personalizar">Color del Texto en los Mensajes:</p>
  <div className="color-picker-inline" style={{ display: 'flex', alignItems: 'center', gap: '1em' }}>
    <div
      className="color-swatch"
      style={{ backgroundColor: messageContentColor }}
      onClick={() => setIsMessageContentColorPickerOpen(!isMessageContentColorPickerOpen)}
    />
    <input
      type="text"
      value={messageContentColor}
      onChange={(e) => setMessageContentColor(e.target.value)}
      className="input-custom"
    />
    {isMessageContentColorPickerOpen && (
      <div className="color-picker-popover">
        <div
          className="color-picker-cover"
          onClick={() => setIsMessageContentColorPickerOpen(false)}
        />
        <SketchPicker
          color={messageContentColor}
          onChangeComplete={(color) => setMessageContentColor(color.hex)}
        />
      </div>
    )}
  </div>
</div>


                    {/* Opción para usar imagen de fondo predeterminada */}
                    <div className="background-options-container"   style={{ marginTop: '2em',}}>
                      <label>
                        <input
                          type="checkbox"
                          checked={useBackgroundImage}
                          onChange={(e) => setUseBackgroundImage(e.target.checked)}
                        />
                        Usar fondo predeterminado
                      </label>
                    </div>

                    </div>
{/* MINI PREVIEW que se ve tal cual el ChatBubble pero en tamaño chico */}
<div
  className="mini-chat-bubble-frontend"
  style={{
    // Si useBackgroundImage es true, usamos la imagen;
    // si es false, el color de fondo proveniente de backgroundColor
    backgroundImage: useBackgroundImage ? `url(${backgroundImage})` : 'none',
    backgroundColor: useBackgroundImage ? 'transparent' : backgroundColor,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}
>
  {/* Encabezado */}
  <div
    className="mini-chat-header-bubble"
    style={{ background: headerColor }}
  >
    <h3 className="mini-h3-bubble-frontend">💬 The Thing Agent</h3>
  </div>

  {/* Contenedor de mensajes */}
  <div className="mini-chat-messages-bubble">
    {/* Mensaje de user */}
    <div className="mini-message user" style={{ background: messageUserColor }}>
    <span
    className="mini-message-content"
    style={{ color: messageContentColor }}  // ← nuevo
  >
    ¡Hola!
  </span>
</div>

    {/* Mensaje de assistant */}
    <div className="mini-message assistant" style={{ background: messageAssistantColor }}>
    <span
    className="mini-message-content"
    style={{ color: messageContentColor }}  // ← nuevo
  >
    Hola, soy la mini vista previa ☺️
  </span>
</div>
  </div>

  {/* Footer mini con input y botón de ejemplo (no clickeable) */}
  <div className="mini-chat-input-container" style={{ opacity: 0.6 }}>
    <input
      type="text"
      placeholder="Escribe tu mensaje..."
      className="mini-chat-input"
      disabled  // Para que no sea clickeable
    />
    <button
      type="button"
      className="mini-send-button"
      disabled // Deshabilitado también
    >
      <img
        src={paperClipButton}
        alt="Mini Send"
        className="mini-send-button-img"
      />
    </button>
  </div>
</div>

                    </div>

                    {/* Color de fondo del chat (si no se usa imagen predeterminada) */}
                    {!useBackgroundImage && (
                      <div className="color-picker-container">
                        <p className='form-personalizar'>Color de fondo del chat:</p>
                        <div className="color-picker-inline">
                          <div
                            className="color-swatch"
                            style={{ backgroundColor: backgroundColor }}
                            onClick={() => setIsBackgroundColorPickerOpen(!isBackgroundColorPickerOpen)}
                          />
                          <input
                            type="text"
                            value={backgroundColor}
                            onChange={(e) => setBackgroundColor(e.target.value)}
                          />
                          {isBackgroundColorPickerOpen && (
                            <div className="color-picker-popover">
                              <div className="color-picker-cover" onClick={() => setIsBackgroundColorPickerOpen(false)} />
                              <SketchPicker
                                color={backgroundColor}
                                onChangeComplete={(color) => setBackgroundColor(color.hex)}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )}


                    {/* Sección para seleccionar imágenes predeterminadas */}
                    <div className="default-bubble-images">
                      <p className='form-personalizar'>Selecciona una burbuja predeterminada:</p>
                      <label className='burbujas-predet'>
    (en tu web, al clickear esta burbuja aparecen <br></br>la burbuja de whatsapp y la de chat web)
  </label>
                      <div className="bubble-image-options">
                             {/* NUEVA burbuja con clase exclusiva */}
  <img
    src={defaultBubbleText}
    alt="Burbuja con texto"
    className={`bubble-image-text-option ${
      bubbleButtonImage === defaultBubbleText ? 'selected' : ''
    }`}
    onClick={() => {
      /* 1) establece la imagen        */
      setBubbleButtonImage(defaultBubbleText);
      /* 2) tamaño por defecto 150 px  */
      setBubbleButtonSize(150);
    }}
  />
    <img
      src={defaultBubbleViolet}
      alt="Burbuja Violeta"
      className={`bubble-image-option ${bubbleButtonImage === defaultBubbleViolet ? 'selected' : ''}`}
      onClick={() => setBubbleButtonImage(defaultBubbleViolet)}
    />
    <img
      src={defaultBubbleBlack}
      alt="Burbuja Negra"
      className={`bubble-image-option ${bubbleButtonImage === defaultBubbleBlack ? 'selected' : ''}`}
      onClick={() => setBubbleButtonImage(defaultBubbleBlack)}
    />
    <img
      src={defaultBubbleWhite}
      alt="Burbuja Blanca"
      className={`bubble-image-option ${bubbleButtonImage === defaultBubbleWhite ? 'selected' : ''}`}
      onClick={() => setBubbleButtonImage(defaultBubbleWhite)}
    />
    <img
      src={defaultBubbleBlue}
      alt="Burbuja Azul"
      className={`bubble-image-option ${bubbleButtonImage === defaultBubbleBlue ? 'selected' : ''}`}
      onClick={() => setBubbleButtonImage(defaultBubbleBlue)}
    />
    <img
      src={defaultBubbleRed}
      alt="Burbuja Roja"
      className={`bubble-image-option ${bubbleButtonImage === defaultBubbleRed ? 'selected' : ''}`}
      onClick={() => setBubbleButtonImage(defaultBubbleRed)}
    />
    <img
      src={defaultBubbleGreen}
      alt="Burbuja Verde"
      className={`bubble-image-option ${bubbleButtonImage === defaultBubbleGreen ? 'selected' : ''}`}
      onClick={() => setBubbleButtonImage(defaultBubbleGreen)}
    />
    <img
      src={defaultBubbleYellow}
      alt="Burbuja Amarilla"
      className={`bubble-image-option ${bubbleButtonImage === defaultBubbleYellow ? 'selected' : ''}`}
      onClick={() => setBubbleButtonImage(defaultBubbleYellow)}
    />

                      </div>
                    </div>

                    {/* Opción para subir una imagen personalizada */}
                    <div className="image-upload-container">
                      <p className='cargar-imagen-bubble'>O carga tu propia imagen para el botón de la Burbuja:</p>
                      <input
                        type="file"
                        accept="image/*"
                       onChange={(e) => {
  const file = e.target.files[0];
  if (!file) return;
  const reader = new FileReader();
  reader.onloadend = () => {
    setBubbleButtonImage(reader.result);   // ← lo que ya tenías
    setIsCustomBubble(true);               // ← NUEVO
  };
  reader.readAsDataURL(file);
}}

                      />
                      
                    </div>


{/* Tamaño del botón de la burbuja */}
<div className="size-picker-container">
                      <img
  src={bubbleButtonImage || defaultBubbleViolet}
  alt="preview"
  style={{
    width : `${bubbleButtonSize * 0.8}px`,
    height: 'auto',
    pointerEvents: 'none',
    marginTop:'1em',
    marginBottom:'1em',
  }}
/>
  <p className="form-personalizar-burbsize">
    Tamaño del botón de la burbuja: {bubbleButtonSize}px
  </p>

  {/* Slider */}
  <input
    type="range"
    min="40"
    max="120"
    step="2"
    value={bubbleButtonSize}
    onChange={(e) => setBubbleButtonSize(Number(e.target.value))}
    className="bubble-size-slider"
  />

  {/* Campo numérico opcional */}
  <input
    type="number"
    min="40"
    max="120"
    value={bubbleButtonSize}
    onChange={(e) => setBubbleButtonSize(Number(e.target.value))}
    className="input-custom"
    style={{ width: '4.5em', marginLeft: '0.8em' }}
  />
</div>




                    {/* Color del Botón de la Burbuja */}
                    <div className="color-picker-container">
                      <p className='form-personalizar'>Color de fondo para tu imagen (transparente predeterminado):</p>
                      <div className="color-picker-inline">
                        <div
                          className="color-swatch"
                          style={{ backgroundColor: bubbleButtonColor }}
                          onClick={() => setIsBubbleButtonColorPickerOpen(!isBubbleButtonColorPickerOpen)}
                        />
                        <input
                          type="text"
                          value={bubbleButtonColor}
                          onChange={(e) => setBubbleButtonColor(e.target.value)}
                        />
                        {isBubbleButtonColorPickerOpen && (
                          <div className="color-picker-popover">
                            <div className="color-picker-cover" onClick={() => setIsBubbleButtonColorPickerOpen(false)} />
                            <SketchPicker
                              color={bubbleButtonColor}
                              onChangeComplete={(color) => setBubbleButtonColor(color.hex)}
                            />
                          </div>
                        )}
                      </div>
                    </div>

{/* Color del Botón del Chat */}
<div className="color-picker-container">
  <p className="form-personalizar">Color de la burbuja de Chat:</p>
  
  {/* Usamos un div con flex para alinear en el mismo renglon */}
  <div className="color-picker-inline" style={{ display: 'flex', alignItems: 'center', gap: '1.2em' }}>
    {/* Swatch + Input */}
    <div
      className="color-swatch"
      style={{ backgroundColor: chatIconButtonColor }}
      onClick={() => setIsChatIconButtonColorPickerOpen(!isChatIconButtonColorPickerOpen)}
    />
    <input
      type="text"
      value={chatIconButtonColor}
      onChange={(e) => setChatIconButtonColor(e.target.value)}
      className="input-custom"
    />
    {isChatIconButtonColorPickerOpen && (
      <div className="color-picker-popover">
        <div
          className="color-picker-cover"
          onClick={() => setIsChatIconButtonColorPickerOpen(false)}
        />
        <SketchPicker
          color={chatIconButtonColor}
          onChangeComplete={(color) => setChatIconButtonColor(color.hex)}
        />
      </div>
    )}

    {/* Pequeña preview del botón en la misma línea */}
    <div
      className="chat-icon-button-preview"
      style={{
        backgroundColor: chatIconButtonColor || '#693DD7',
        pointerEvents: 'none',  // Para que NO sea clickeable
      }}
    >
        {/* Pequeña vista previa en línea */}
        <div
          className="chat-icon-preview"
          style={{
            color: chatIconColor,
            background: 'none',
            fontSize: '1.8em',
            pointerEvents: 'none',
          }}
        >
          <FontAwesomeIcon icon={faComments} />
        </div>
    </div>
  </div>
</div>

<div className="color-picker-container">
      <p className="form-personalizar">Color del Ícono de Chat:</p>
      <div className="color-picker-inline" style={{ display: 'flex', alignItems: 'center', gap: '1.2em' }}>
        <div
          className="color-swatch"
          style={{ backgroundColor: chatIconColor }}
          onClick={() => setIsChatIconColorPickerOpen(!isChatIconColorPickerOpen)}
        />
        <input
          type="text"
          value={chatIconColor}
          onChange={(e) => setChatIconColor(e.target.value)}
          className="input-custom"
        />
        {isChatIconColorPickerOpen && (
          <div className="color-picker-popover">
            <div
              className="color-picker-cover"
              onClick={() => setIsChatIconColorPickerOpen(false)}
            />
            <SketchPicker
              color={chatIconColor}
              onChangeComplete={(color) => setChatIconColor(color.hex)}
            />
          </div>
        )}
      </div>
    </div>
                    <div className="toggle-chat-icon-button-container">
  <label>
    <input
      type="checkbox"
      checked={showChatIconButton}
      onChange={(e) => setShowChatIconButton(e.target.checked)}
    />
    Mostrar burbuja de chat web<br />
    (si desactiva esta opción, solo aparecerá la burbuja de whatsapp)
  </label>
</div>



                    {/* Botón para generar el script personalizado */}
                    <button className='generate-custom-script' onClick={handleCopyCustomScript}>
                      Generar Código Personalizado
                    </button>
                  </div>
                  </div>
                )}
              </div>
            </div>
          </div>        
        )}

        </div>

        <div className='buttons-training-container'>

        {isEditingInstructions ? (
          <button
  className="save-instructions-button"
  onClick={handleSaveInstructions}
  disabled={isSavingInstructions}
>
  {isSavingInstructions ? <span className="spinner-saving" /> : 'GUARDAR'}
</button>
) : (
  <button className='edit-instructions-button' onClick={handleEditInstructions}>Editar Agente</button>
)}

<button className="delete-agent-button" onClick={handleDeleteAssistant}>
          Eliminar Agente
        </button>

          </div>


        </div>      


        <div className="chat-section-container">
        <div className="chat-container">
          
          <h2 className="chat-header">{assistantDetails.name}</h2>

          <div className="chat-header-container">
  <label className="vista-preliminar">Vista preliminar</label>
  <button
    className="clear-thread-button"
    onClick={handleClearThread}
    title="Borrar conversación"
  >
    <img
      src={paintBrushIcon}
      alt="Borrar conversación"
      style={{ width: '1.2em', height: 'auto' }}
    />
  </button>
</div>


          <div className="chat-messages">
          {messages.map((message, index) => {
  if (message.messageType === 'image') {
    return (
      <div key={index} className="message-training-image">
        <img src={message.content} alt="assistant sent" style={{ maxWidth: '350px', borderRadius: '10px' }} />
      </div>
    );
  }

  if (message.messageType === 'file' || message.messageType === 'pdf') {
    return (
<div key={index} className="message-training-file">
  <a
    href={message.content}
    target="_blank"
    rel="noopener noreferrer"
    style={{ display: 'inline-block', cursor: 'pointer' }}
  >
    <embed
      src={message.content}
      type="application/pdf"
      width="300"
      height="490"

    />
  </a>
</div>
    );
  }

  if (message.messageType === 'office') {
    return (
      <div key={index} className="message-training-file">
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(message.content)}`}
          width="300"
          height="200"
          frameBorder="0"
          title={message.name || 'office-preview'}
        />
      </div>
    );
  }

  if (message.messageType === 'video') {
    return (
      <div key={index} className="message-training-video">
        <video controls style={{ maxWidth: '350px', borderRadius: '10px' }}>
          <source src={message.content} />
          Tu navegador no soporta el tag de video.
        </video>
      </div>
    );
  }
  
  if (message.messageType === 'audio') {
    return (
      <div key={index} className="message-training-audio">
        <audio controls>
          <source src={message.content} />
          Tu navegador no soporta el tag de audio.
        </audio>
      </div>
    );
  }
  

  // tu render por defecto para texto…
  return (
    <div key={index} className={`message-training ${message.role === 'user' ? 'user' : 'assistant'}`}>
      <div className="message-content-training" dangerouslySetInnerHTML={{ __html: formatMessageContent(message.content) }} />
    </div>
  );
})}



{isLoading && (
  <div className="message assistant loading-container">
    <div className="loading-dots">
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </div>
  </div>
)}
          </div>
          </div>
          <div className="chat-input-container">
  <input 
    type="text" 
    value={input} 
    onChange={(e) => setInput(e.target.value)} 
    placeholder="Escribe tu mensaje" 
    className="chat-input"
    onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
  />
  <button onClick={handleSendMessage} className="chat-button" disabled={isLoading}>
    {isMobile ? (
      isLoading ? (
        <div className="spinner-assistant" aria-label="Enviando mensaje"></div>
      ) : (
        <img src={paperClipButton} alt="Enviar" />
      )
    ) : (
      "Enviar"
    )}
  </button>
</div>

        </div>
      </div>
      <div className="back-button-container">
        <button onClick={handleTryChatBubble}  className='edit-instructions-button'>
            Probar bubble chat
          </button>

          {/* Botón para abrir el modal */}
          <button onClick={handleOpenModal}  className='save-instructions-button'>
          Implementar en redes/website
          </button>
      </div>

{/* ---------- GALERÍA DE IMÁGENES ---------- */}
{/* ---------- GALERÍA DE ARCHIVOS ---------- */}
{isGalleryOpen && (
  <div className="modal-overlay">
    <div className="modal-galeria">
      <button
        className="close-button-imp"
        onClick={() => setIsGalleryOpen(false)}
      >
        x
      </button>

      <h2 className="implementacion-h2">Archivos del asistente</h2>

      {galleryFiles.length === 0 && (
        <p style={{ textAlign: 'center' }}>No hay archivos en la carpeta.</p>
      )}

      <div className="galeria-grid">
        {galleryFiles.map(({ url, type, name }) => (
          <div key={url} className="galeria-item">
{type === 'image' && <img src={url} alt={name} />}
{type === 'video' && (
  <video width="100%" height="150" controls>
    <source src={url} />
  </video>
)}
{type === 'audio' && (
  <VoiceMessagePlayer src={url} style={{ width: '100%' }} />
)}
{type === 'pdf'   && (
  <embed src={url} type="application/pdf" width="100%" height="150" />
)}
{type === 'office' && (
  <iframe
    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
    width="100%"
    height="150"
    frameBorder="0"
    title={name}
  />
)}
{type === 'file'  && (
  <a href={url} target="_blank" rel="noopener noreferrer">
    {name}
  </a>
)}


            <p className="galeria-filename">{name}</p>
          <button
  className="delete-file-btn"
  title="Eliminar archivo"
  onClick={async () => {
    if (!window.confirm('¿Eliminar este archivo?')) return;
    try {
      const res = await fetch(
        'https://backend.thethingapp.com/api/delete-file',
        {
          method : 'POST',
          headers: { 'Content-Type': 'application/json' },
          body   : JSON.stringify({
            assistantId,   // ←  usa la misma variable que ya tienes en el componente
            imageUrl: url  // ←  el url que llega en el map
          })
        }
      );
      const data = await res.json();
      if (data.success) {
        setGalleryFiles(prev => prev.filter(f => f.url !== url));
        setHasFiles(prev => prev.length > 1);   // o simplemente  setHasFiles(prev.length>1)
        toast.success('🗑 Archivo eliminado con éxito');
      } else {
        toast.error(`❌ ${data.error || 'Error eliminando el archivo.'}`);
      }
    } catch (e) {
      console.error('Error borrando archivo:', e);
      toast.error('❌ Error eliminando el archivo.');
    }
  }}
>
  <FontAwesomeIcon icon={faTrash} />
</button>

          </div>
        ))}
      </div>
    </div>
  </div>
)}

</div>
);
};
export default AssistantChat;
